// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"160":"components","519":"canvas","628":"guide","759":"echarts"}[chunkId] + "." + {"160":"79177e65","519":"54cb779b","628":"15e9d8de","759":"62e8727c"}[chunkId] + ".js";
};